const restoreEquipments = {
  toastr: 'Equipamento restaurado',
  toastr1: 'Equipamento restaurado com sucesso'
};

export default restoreEquipments;